import { render } from "./Editar.vue?vue&type=template&id=05a765ba"
const script = {}
script.render = render

export default script